<template>
  <div class="btn-group btn-group-sm">
    <button v-if="can_access('email','modify')" class="btn" :class="row.sent_status?'btn-completed':'btn-pending'" title="Send Mail" @click="showModal()"><i class="fa fa-send"></i> {{row.sent_status?'Re-Send':'Send'}}</button>

    <b-modal ref="email-send-out" title="Send E-Mail" size="xl" hide-footer v-if="can_access('email','modify')">
      <div class="form-group">
          <label class="col-lg-2 control-label">To</label>
          <div class="col-lg-12">
              <input type="text" placeholder="" :value="rowData.to" :readonly="true" class="form-control">
          </div>
      </div>
      <div class="form-group">
          <label class="col-lg-2 control-label">Subject</label>
          <div class="col-lg-12">
              <input type="text" placeholder="" v-model="rowData.subject" class="form-control">
          </div>
      </div>
      <div class="form-group">
          <label class="col-lg-2 control-label">Message</label>
          <div class="col-lg-12">
              <vue-editor v-model="rowData.body" :editorToolbar="customToolbar"></vue-editor>
          </div>
      </div>
      <div class="form-group" v-if="rowData.attachments_path">
          <label class="col-lg-2 control-label">Attachment(s):</label>
          <div class="col-lg-12">
              <a class="" v-for="file in rowData.attachments_path" :key="file" target="_blank"  :href="get_baseURL()+file"><i class="fa fa-file-pdf-o pdf-icon" aria-hidden="true"></i></a>
          </div>
      </div>

      <div class="form-group">
        <div class="col-lg-12">
          <button type="button" class="btn btn-lg btn-info pull-right mt-2" @click.prevent="send_report">Send</button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import $ from 'jquery';
import common from '@/assets/js/common.js';
import { mapActions } from 'vuex';
import { VueEditor } from "vue2-editor";
export default {
  props: ['row', 'nested','refresh'],
  components: {  VueEditor },
  mixins: [common],
  data(){
    return {
      show: 1,
      customToolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }]],
      rowData:{},
      action:''
    }
  },
  mounted () {
    //$(this.$el).find('button[title]').tooltip()
  },
  computed: {
  },
  methods: {
    ...mapActions('layout', ['changeBodyLoading']),
    send_report() {
      this.changeBodyLoading(true);
      this.call_axios('send_email','post',this.rowData).then(res => {
        this.changeBodyLoading(false);
        this.$refs['email-send-out'].hide();
        this.refresh();
        if(res.response.code==0){
            this.$toasted.success("Mail sent successfully",{duration:1500});
            return
        }
        this.$toasted.success("Something went wrong",{duration:1500});
      });
    },
    toggleNestedComp (comp) {
      const { nested } = this
      if (nested.comp === comp) return nested.$toggle()
      nested.$toggle(comp, true)
    },
    showModal() {
        this.rowData = this.duplicate(this.row);
        this.rowData.email_id = this.row.id; 
        this.$refs['email-send-out'].show()
    },
  }
}
</script>
<style>
.-nested-comp-open-btn {
  color: #fff !important;
  background-color: #337ab7 !important;
}
dd, dt {
    line-height: 1.42857143;
}
</style>
